import { CostCategory } from '../types';

const COST_CATEGORY_ICON_MAP = {
  [CostCategory.KWH_FIXED_CHARGE]: 'mdi-flash',
  [CostCategory.ON_PEAK_UNIT_CHARGE]: 'mdi-white-balance-sunny',
  [CostCategory.OFF_PEAK_UNIT_CHARGE]: 'mdi-weather-night',
  [CostCategory.SUNDAY_UNIT_CHARGE]: 'mdi-finance',
  [CostCategory.MISC_UNIT_CHARGE]: 'mdi-counter',
  [CostCategory.ON_PEAK_DEMAND_CHARGE]: 'mdi-flash',
  [CostCategory.OFF_PEAK_DEMAND_CHARGE]: 'mdi-gauge-low',
  [CostCategory.SUNDAY_DEMAND_CHARGE]: 'mdi-calendar-weekend-outline',
  [CostCategory.OIL_SURCHARGE]: 'mdi-oil',
  [CostCategory.KVA_PER_UNIT_CHARGE]: 'mdi-gauge',
  [CostCategory.SERVICE_CHARGE]: 'mdi-wrench',
  [CostCategory.VAT]: 'mdi-percent',
  [CostCategory.REA]: 'mdi-account-group',
  [CostCategory.EWURA]: 'mdi-shield-check',
};

const UNIQUE_CATEGORY_COLORS = [
  'green',
  'purple',
  'red',
  'teal',
  'indigo',
  'cyan',
  'deep-purple',
  'brown',
  'pink',
  'amber',
];

const CATEGORY_SUFFIX_COLORS = {
  DEMAND_CHARGE: 'orange',
  UNIT_CHARGE: 'blue',
};

const getIconKey = (category = '') => {
  if (typeof category === 'string') {
    return category;
  }

  return category.category_code || category.code || category.category_name || category.name || '';
};

const getColorKeys = (category = '') => {
  if (typeof category === 'string') {
    return [category];
  }

  return [
    category.category_code,
    category.code,
    category.category_name,
    category.name,
  ].filter(Boolean);
};

const getCategoryCode = (category = '') => {
  if (typeof category === 'string') {
    return category;
  }

  return category.category_code || category.code || '';
};

const getSuffixColorKey = (category = '') => {
  const colorKeys = getColorKeys(category).map((value) => (
    value.toUpperCase().replace(/\s+/g, '_')
  ));

  return Object.keys(CATEGORY_SUFFIX_COLORS).find((suffix) => (
    colorKeys.some((colorKey) => colorKey.endsWith(suffix))
  ));
};

const getCategoryOrder = (category = {}) => Number(
  category.calculation_order ?? category.order ?? Number.MAX_SAFE_INTEGER,
);

export const getCostCategoryIcon = (category = '') => {
  const iconKey = getIconKey(category).toUpperCase();
  return COST_CATEGORY_ICON_MAP[iconKey] || 'mdi-currency-usd';
};

export const getCostCategoryColor = (category = '', categories = []) => {
  const suffixColorKey = getSuffixColorKey(category);

  if (suffixColorKey) {
    return CATEGORY_SUFFIX_COLORS[suffixColorKey];
  }

  const categoryCode = getCategoryCode(category);
  const orderedCategories = [...categories]
    .filter((item) => !getSuffixColorKey(item))
    .sort((a, b) => (
      getCategoryOrder(a) - getCategoryOrder(b)
    ));
  const categoryIndex = orderedCategories.findIndex(
    (cat) => getCategoryCode(cat) === categoryCode,
  );

  if (categoryIndex < 0) {
    return 'grey';
  }

  return UNIQUE_CATEGORY_COLORS[categoryIndex % UNIQUE_CATEGORY_COLORS.length];
};

export default COST_CATEGORY_ICON_MAP;
